module.exports = __webpack_public_path__ + "media/toolkits/COVID-desktop-ecosystem-fbb294ca.png";